// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/maps-background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: cover;
  padding: 50px;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

.full-height {
  height: 100%;
}

.full-width {
  width: 100%;
}

.center-content {
  line-height: 0.2rem;
  margin: auto;
  margin-left: 0;
  color: #ffffff;
}

.bottom-content {
  width: 70%;
  position: absolute;
  bottom: 0;
}

.input-readonly {
  cursor: default;
  color: #ffffff;
}

.input-container {
  width: 250px;
}

.password-light {
  color: #a7afbe;
  font-size: 14px;
  margin: 0;
  width: 250px;
}

.error-input {
  margin-top: 10px;
  width: 250px;
}

.no-margin {
  margin: 0;
}

.mt-10 {
  margin-top: 10px;
}

.mt-30 {
  margin-top: 30px;
}

.mb-0 {
  margin-bottom: 0;
}

.signin-btn {
  border-radius: 20px;
  padding: 0 30px;
}

.logging-in {
  color: #a7afbe;
  font-weight: lighter;
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.progress {
  margin-top: -7px;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/screens/enter-password/styles/index.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,WAAA;AACJ","sourcesContent":[".layout {\n    height: 100vh;\n    background-image: url('../../../../public/maps-background.webp');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-color: transparent;\n    background-size: cover;\n    padding: 50px;\n    flex-direction: column;\n    overflow: hidden;\n    width: 100%;\n}\n\n.full-height {\n    height: 100%;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.center-content {\n    line-height: 0.2rem;\n    margin: auto;\n    margin-left: 0;\n    color: #ffffff;\n}\n\n.bottom-content {\n    width: 70%;\n    position: absolute;\n    bottom: 0;\n}\n\n.input-readonly {\n    cursor: default;\n    color: #ffffff;\n}\n\n.input-container {\n    width: 250px;\n}\n\n.password-light {\n    color: #a7afbe;\n    font-size: 14px;\n    margin: 0;\n    width: 250px;\n}\n\n.error-input {\n    margin-top: 10px;\n    width: 250px;\n}\n\n.no-margin {\n    margin: 0;\n}\n\n.mt-10 {\n    margin-top: 10px;\n}\n\n.mt-30 {\n    margin-top: 30px;\n}\n\n.mb-0 {\n    margin-bottom: 0;\n}\n\n.signin-btn {\n    border-radius: 20px;\n    padding: 0 30px;\n}\n\n.logging-in {\n    color: #a7afbe;\n    font-weight: lighter;\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n}\n\n.progress {\n    margin-top: -7px;\n    float: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
